<div class="iframe-wrapper" *ngIf="!loading && iframeSrc">
    <iframe [src]="iframeSrc | safeUrl"></iframe>
</div>